import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Icon } from 'react-icons-kit';
import { search } from 'react-icons-kit/fa/search';
import { ic_chevron_left } from 'react-icons-kit/md/ic_chevron_left';
import { mapO } from 'react-icons-kit/fa/mapO';
import ReactTooltip from 'react-tooltip';

import List from 'components/List/List';
import Actions from 'components/Actions/Actions';
import Filters from 'components/Filters/Filters';


import './Menu.css';

declare var CONFIGURATIONS;

class Menu extends Component {
  constructor(props) {
    super(props);
    this.tooltipRef = null;
    this.state = {
      searched: false,
    };
  }

  handleClick = () => {
    this.props.openMenuHandler();
    if (this.tooltipRef !== null) {
      ReactTooltip.hide(this.tooltipRef);
    }
  }

  updateSearched = (searched) => {
    this.setState({ searched });
  }

  render() {
    const { t, menuOpened, flights, block, unblock, onlyButton, selectedFeatures, selectedFullFeatures, centersLayer, flightLayer,
      flightName, updateFlights, selectTempFlight, selectFeatures, addCentersLayer, allFlights, setAllFlights, } = this.props;
    const style = {
      left: menuOpened ? '450px' : '0',
    };

    if (onlyButton) {
      return (
        <nav className={'nav-wrapper icon-w0'}>
          <div ref={ref => this.tooltipRef = ref} className='collapseButton' style={{ left: '450px' }} data-event="mouseover"
            onClick={this.handleClick} data-tip data-for={'menuTooltip'} data-event-off="mouseout">
            <span className='mapPosition'><Icon size={'32px'} icon={ mapO } /></span>
            <span className='searchPosition'><Icon size={'29px'} icon={ search } /></span>
          </div>
          <ReactTooltip id={'menuTooltip'} effect='solid' place='right' globalEventOff='touchstart'>
            {!menuOpened ? t('menu.search_on_view') : t('menu.close') }
          </ReactTooltip>
        </nav>
      );
    } else {
      return (
        <nav className={menuOpened ? 'nav-wrapper' : 'nav-wrapper icon-w0'}>
          <div ref={ref => this.tooltipRef = ref} className='collapseButton' style={style} data-event="mouseover" data-event-off="mouseout"
            onClick={this.handleClick} data-tip data-for={'menuTooltip'}>
            { menuOpened ?
              <Icon size={'36px'} icon={ic_chevron_left} />
            : <span className='mapPosition'><Icon size={'32px'} icon={mapO} /></span> }
            { !menuOpened ?
              <span className='searchPosition'><Icon size={'29px'} icon={ search } /></span>
            : null }
          </div>
          <ReactTooltip id={'menuTooltip'} effect='solid' place='right'>
            {!menuOpened ? t('menu.search_on_view') : t('menu.close') }
          </ReactTooltip>
          <Filters block={block} unblock={unblock} setSearched={this.updateSearched} setFlights={updateFlights}
            setSelectedFlight={selectTempFlight} flightLayer={flightLayer} setAllFlights={setAllFlights} />
          { this.state.searched ?
            <React.Fragment>
              <Actions selectFeatures={selectFeatures} selectedFeatures={selectedFeatures} selectedFullFeatures={selectedFullFeatures}
                flights={flights} addCentersLayer={addCentersLayer} centersLayer={centersLayer} block={block} unblock={unblock} />
              <List selectFeatures={selectFeatures} selectedFeatures={selectedFeatures} selectedFullFeatures={selectedFullFeatures}
                flightLayer={flightLayer} flightName={flightName} block={block} unblock={unblock}
                selectTempFlight={selectTempFlight} centersLayer={centersLayer} allFlights={allFlights} />
            </React.Fragment>
          : null }
        </nav>
      );
    }
  }
}

export default translate()(Menu);
